import { render, staticRenderFns } from "./EditableList.vue?vue&type=template&id=50acb48c&scoped=true&"
import script from "./EditableList.vue?vue&type=script&lang=ts&"
export * from "./EditableList.vue?vue&type=script&lang=ts&"
import style0 from "./EditableList.vue?vue&type=style&index=0&id=50acb48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50acb48c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
